<div class="errors-container">
    <ng-container *ngFor="let error of systemErrors">
        <div
            *ngIf="getErrorLocation(error[0]) === 'eap'"
            (click)="handlePageSelected('eap')"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: eapTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'ops'"
            (click)="handlePageSelected('ops')"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: opsTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div *ngIf="isFcuError(error[0])" (click)="handleFcuSelected(error[0])">
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: fcuTranslationString,
                        errors: error[1],
                        isFcuError: true
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'fu'"
            (click)="handleFuSelected(error[0])"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: fuTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'slots'"
            (click)="handleFuSelected(error[0])"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: slotTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'comms'"
            (click)="handleCommIFSelected(error[0])"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: commIFTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'ports'"
            (click)="handleCommIFSelected(error[0])"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: commIFPortTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
        <div
            *ngIf="getErrorLocation(error[0]) === 'printers'"
            (click)="handlePageSelected('printers')"
        >
            <ng-container
                *ngTemplateOutlet="
                    errorTemplate;
                    context: {
                        errorLocation: error[0],
                        type: printerTranslationString,
                        errors: error[1]
                    }
                "
            >
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template
    #errorTemplate
    let-errorLocation="errorLocation"
    let-translationString="type"
    let-errors="errors"
    let-isFcuError="isFcuError"
>
    <div class="error-container">
        <div class="top-row">
            <div class="name-container">
                <mat-icon svgIcon="status-indicator" style="color: #e41b1b">
                </mat-icon>
                {{ translationString.concat(".", "title") | translate }}
                <div *ngIf="!isFcuError">
                    {{ " " + getIndex(errorLocation) }}
                </div>
                <div *ngIf="isFcuError">
                    {{ " " + getFcuLetter(errorLocation) }}
                </div>
            </div>
            <div
                class="location-container"
                *ngFor="let location of errorlocation(errorLocation)"
            >
                <mat-icon svgIcon="location_on"> </mat-icon>
                {{
                    ["system-status", location.location, "title"].join(".")
                        | translate
                }}
                {{ " " + location.index }}
            </div>
        </div>

        <div
            class="status-container"
            *ngIf="translationString !== commIFPortTranslationString"
        >
            <div
                class="status-wrapper alarm-font"
                *ngFor="let error of errors | keyvalue"
            >
                {{
                    translationString.concat(".", getErrorType(error.value))
                        | translate
                }}
                <mat-icon svgIcon="status-error" class="icon"> </mat-icon>
            </div>
        </div>
    </div>
</ng-template>
